module.exports = __webpack_public_path__ + "img/footer_store_google.1dc4dcc.png";